/**
 * 3.0 콜랩 스레드 스타일.
 * @description 앱 스레드 줄의 웹 대응 — 머리(아바타 · 이름 · 표시 · 날짜) → 본문 → 링크 · 사진 · 고른
 *   작품 · 집행 결과 → 하트 · 댓글 숫자. 줄 사이는 1px 선으로 가른다. 읽기만 한다.
 */
export const collabV3ThreadStyles = {
  section: "flex w-full flex-col gap-[var(--fw-space-gap-md)]",
  heading: "fw-h3 text-[var(--fw-color-content-neutral-primary)]",
  empty: "fw-b2 py-[var(--fw-space-inset-lg)] text-[var(--fw-color-content-neutral-tertiary)]",
  list: "flex flex-col [&>*+*]:border-t-[length:var(--fw-border-sm)] [&>*+*]:border-[var(--fw-color-border-subtle)]",
  /** 글 전체를 덮는 앱 버튼이 이 안에서만 위에 서도록 쌓임 맥락을 가둔다(하단 고정 바를 덮지 않게) */
  item: "relative isolate flex flex-col gap-[var(--fw-space-gap-md)] py-[var(--fw-space-inset-lg)]",
  author: "flex items-center gap-[var(--fw-space-gap-sm)]",
  authorTexts:
    "flex min-w-0 flex-1 flex-wrap items-center gap-x-[var(--fw-space-gap-sm)] gap-y-[var(--fw-space-gap-xxs)]",
  authorName: "fw-l2 truncate text-[var(--fw-color-content-neutral-primary)]",
  date: "fw-caption text-[var(--fw-color-content-neutral-tertiary)]",
  label: "fw-caption-strong text-[var(--fw-color-content-neutral-tertiary)]",
  content:
    "fw-b1 whitespace-pre-line break-words text-[var(--fw-color-content-neutral-primary)]",
  media: "grid grid-cols-3 gap-[var(--fw-space-gap-sm)]",
  mediaItem:
    "relative aspect-square overflow-hidden rounded-[var(--fw-radius-md)] bg-[var(--fw-color-surface-neutral-secondary)]",
  link: [
    "flex items-center gap-[var(--fw-space-gap-md)] rounded-[var(--fw-radius-md)] p-[var(--fw-space-inset-md)]",
    "border-[length:var(--fw-border-sm)] border-[var(--fw-color-border-subtle)]",
  ].join(" "),
  /** 바깥 링크는 글을 덮는 앱 버튼보다 위 — 따로 눌린다 */
  linkHover:
    "relative z-20 bg-[var(--fw-color-surface-neutral-primary)] transition-colors hover:bg-[var(--fw-color-surface-neutral-primary-hovered)]",
  linkThumb:
    "relative size-[var(--fw-size-control-lg)] shrink-0 overflow-hidden rounded-[var(--fw-radius-sm)] bg-[var(--fw-color-surface-neutral-secondary)]",
  linkTexts: "flex min-w-0 flex-1 flex-col",
  linkTitle: "fw-l2 truncate text-[var(--fw-color-content-neutral-primary)]",
  linkMeta: "fw-caption truncate text-[var(--fw-color-content-neutral-tertiary)]",
  box: "flex flex-col gap-[var(--fw-space-gap-sm)] rounded-[var(--fw-radius-md)] bg-[var(--fw-color-surface-neutral-secondary)] p-[var(--fw-space-inset-md)]",
  usage:
    "fw-b2 flex items-baseline justify-between gap-[var(--fw-space-gap-sm)] text-[var(--fw-color-content-neutral-secondary)]",
  usageTotal: "fw-l2 text-[var(--fw-color-content-neutral-primary)]",
  picked: "grid grid-cols-3 gap-[var(--fw-space-gap-sm)]",
  pickedItem: "flex min-w-0 flex-col gap-[var(--fw-space-gap-xs)]",
  pickedName: "fw-caption truncate text-[var(--fw-color-content-neutral-secondary)]",
  /** 숫자만 — 하트 · 댓글은 앱에서 남긴다 */
  reactions:
    "fw-caption flex w-fit items-center gap-[var(--fw-space-gap-md)] text-[var(--fw-color-content-neutral-tertiary)]",
  reaction: "flex items-center gap-[var(--fw-space-gap-xs)]",
  reactionIcon: "size-[var(--fw-size-icon-xs)]",
};

export const COLLAB_V3_THREAD_IMAGE_SIZES = "(min-width: 768px) 200px, 33vw";
/** 한 글에서 웹에 보이는 사진 수 — 나머지는 앱에서 본다 */
export const COLLAB_V3_THREAD_MAX_IMAGES = 6;
